export default "__VITE_ASSET__51908c52__"